module.exports = __webpack_public_path__ + "img/logo-nav.da639b5d.png";